module.exports = __webpack_public_path__ + "img/gaia.50b91e8f.png";